<template>
  <div class="toggle-switch block">
    <div class="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
      <input
        type="checkbox"
        name="toggle"
        id="toggle"
        class="toggle-checkbox absolute block w-8 h-8 rounded-full bg-white border-4 appearance-none cursor-pointer"
        :checked="enabled"
      />
      <label
        for="toggle"
        class="toggle-label block overflow-hidden h-8 rounded-full bg-gray-300 cursor-pointer shadow-lg"
      ></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'toggleSwitch',
  props: ['enabled'],
};
</script>

<style>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #68d391;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #68d391 !important;
}
</style>
